<template>
	<div class="multi-quiz__button btn btn-progres " @click="onClick">
		<div class="btn__content">{{text}}</div>
	</div>
</template>

<script>
	export default {

		props: [
			'onClick',
			'text',
		],

		data(){
			return{
			}
		},

		mounted(){
		},

		watch:{
		},

		computed: {

		},

		methods:{
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/multiquiz/Button.vue